<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div *ngIf="historyService.logicalTopology" class="global-action-toolbar">
    <ng-container *ngIf="!potentiallyCorruptedProject">
        <ng-container *ngIf="!historyService.isEditModeEnabled">
            <button
                (click)="projectLockOrRequestLock()"
                *windeHasAnyAuthority="UserAuthorities.PROJECT_EDIT"
                class="btn btn-link btn-sm no-padding-left btn--lock-project"
                windeTransparent
            >
                <sui-svg-icon icon="lock" />
                <span [tooltipText]="lockButtonTooltipText" position="bottom" suiTooltip>
                    {{ isProjectLocked ? 'Read Only' : 'Locked project' }}
                </span>
            </button>
        </ng-container>
        <button
            *windeHasAnyAuthority="UserAuthorities.ANY_USER"
            [routerLink]="['/', { outlets: { popup: 'project-view/request-design-quotation' } }]"
            class="btn btn-link btn-sm no-padding-left btn--request-design"
            windeTransparent
        >
            <sui-svg-icon icon="question-circle" />
            Request Design Quotation
        </button>
    </ng-container>
</div>

<div
    *ngIf="historyService.logicalTopology && historyService.isEditModeEnabled && historyService.toolbarMode === modeType.SELECT_AREA_MODE"
    class="map-selectors-container"
>
    <button
        class="circle-background"
        [ngClass]="{ active: squareSelectionService.selectAreaMode === selectAreaModeEnum.SQUARE_SELECTOR }"
        (click)="selectAreaModeChanged(selectAreaModeEnum.SQUARE_SELECTOR)"
    >
        <div class="shape square"></div>
    </button>
    <button
        class="circle-background"
        [ngClass]="{ active: squareSelectionService.selectAreaMode === selectAreaModeEnum.CIRCLE_SELECTOR }"
        (click)="selectAreaModeChanged(selectAreaModeEnum.CIRCLE_SELECTOR)"
    >
        <div class="shape circle"></div>
    </button>
    <button
        class="circle-background"
        [ngClass]="{ active: squareSelectionService.selectAreaMode === selectAreaModeEnum.POLIGONE_SELECTOR }"
        (click)="selectAreaModeChanged(selectAreaModeEnum.POLIGONE_SELECTOR)"
    >
        <div class="shape trapezoid"></div>
    </button>
</div>
